export default __webpack_public_path__ + "static/media/consufedtravolta.7a20d452.gif";